<div
	*ngIf="editMode && !isAddMode"
	class="overlay bg-black opacity-30 fixed top-0 left-0 w-screen h-screen z-30 lg:p-24px"
></div>
<div class="mb-[24px]">
	<div>
		<!-- country & price Section Start -->

		<div class="flex flex-row justify-between py-2 min-h-[40px]">
			<p class="text-[#1C252E] font-medium text-lg leading-5">
				{{ 'OFFERS.COUNTRY_PRICE' | translate }}
			</p>

			<div
				(click)="changeEditMode()"
				*ngIf="!editMode && !isAddMode && !offerData?.hasEnded"
				class="flex gap-1 ltr:mr-6 rtl:ml-6 hover:cursor-pointer"
			>
				<img class="w-5 max-h-5" src="assets/images/edit-blue.svg" alt="" />
				<p class="text-[#009EF7]">{{ 'ACTIONS.EDIT' | translate }}</p>
			</div>
		</div>
		<div
			class="flex flex-col custom-shadow p-24px gap-[14px] rounded-12px bg-off-white  {{
				editMode && !isAddMode ? 'z-40' : ''
			}} relative  "
		>
			<div [formGroup]="offerForm">
				<!-- country -->
				<div *ngIf="editMode || isAddMode">
					<p class="text-font-16 text-dark-grey ltr:DIN-Bold font-bold">
						{{ 'OFFERS.COUNTRY' | translate }}
						<span class="text-[#7e2eb3]">*</span>
					</p>
					<mat-radio-group
						formControlName="countryId"
						aria-label="Select an option"
						(change)="getServiceProviders()"
					>
						<mat-radio-button
							class="ltr:mr-[24px] rtl:ml-[24px] text-font-14 text-dark-grey"
							[value]="224"
							[checked]="offerData?.country?.id == 224"
							>{{ 'COUNTRIES.EGYPT' | translate }}</mat-radio-button
						>
						<mat-radio-button
							[value]="103"
							[checked]="offerData?.country?.id == 103"
							class="text-font-14 text-dark-grey"
							>{{ 'COUNTRIES.SAUDI_ARABIA' | translate }}</mat-radio-button
						>
					</mat-radio-group>
				</div>
				<div
					*ngIf="!editMode && !isAddMode"
					class="w-full max-h-[73px] m-0 p-0 border-solid border-b-2"
				>
					<p class="mb-0 pb-0 text-[#6E7191] mt-[16px]">
						{{ 'OFFERS.COUNTRY' | translate }}
					</p>
					<p class="viewMode">
						{{
							translate.currentLang == 'ar'
								? offerData?.country?.name?.ar
								: offerData?.country?.name?.en
						}}
					</p>
				</div>

				<!-- service provider -->
				<div *ngIf="editMode || isAddMode" class="mt-[16px]">
					<p class="text-font-16 text-dark-grey ltr:DIN-Bold font-bold">
						{{ 'OFFERS.SERVICE-PROVIDER' | translate }}
						<span class="text-[#7e2eb3]">*</span>
					</p>
					<mat-radio-group
						formControlName="isForAllProviders"
						(change)="offerTypeChanged()"
						aria-label="Select an option"
					>
						<mat-radio-button
							class="ltr:mr-[24px] rtl:ml-[24px] text-font-14 text-dark-grey"
							[value]="true"
							(change)="getController('offerServiceProviders').reset()"
							>{{ 'OFFERS.ALL' | translate }}</mat-radio-button
						>
						<mat-radio-button
							class="text-font-14 text-dark-grey"
							[value]="false"
							>{{ 'OFFERS.INDIVIDUAL' | translate }}</mat-radio-button
						>
					</mat-radio-group>
					<br />
					<mat-form-field
						appearance="outline"
						*ngIf="getController('isForAllProviders')?.value == false"
						class="w-full custom-autocomplete"
					>
						<mat-select
							panelClass=" my-0 mx-24px  {{
								editMode ? 'custom-ed-hight' : 'custom-hight custom-width'
							}} "
							placeholder="{{ 'OFFERS.SELECT_S_P' | translate }}"
							formControlName="offerServiceProviders"
							multiple
							[compareWith]="compareWith"
						>
							<mat-select-trigger class="text-main-color-black">
								{{
									getController('offerServiceProviders')?.value?.length
										? getController('offerServiceProviders')?.value[0]
												?.businessName
										: ''
								}}
								<span
									*ngIf="
										getController('offerServiceProviders').value?.length > 1
									"
									class="additional-selection"
								>
									(+{{
										getController('offerServiceProviders').value.length - 1
									}}
									{{
										getController('offerServiceProviders').value?.length === 2
											? ('GENERAL.OTHER' | translate)
											: ('GENERAL.OTHERS' | translate)
									}})
								</span>
							</mat-select-trigger>
							<div class="select-container">
								<mat-form-field
									class="w-[97%] ltr:ms-[12px] rtl:me-[12px] mt-2 bg-light-grey text-main-color-black relative overflow-hidden"
									appearance="outline"
								>
									<div>
										<img
											class="absolute ltr:left-0 rtl:right-0 inline-block top-[9px] pr-12px"
											src="./assets/images/search-normal.svg"
											alt=""
										/>
									</div>
									<input
										matInput
										type="text"
										(keydown)="$event.stopPropagation()"
										[formControl]="keyWord"
										placeholder="{{ 'OFFERS.SEARCH' | translate }}"
										class="absolute w-[96%] ltr:left-10 rtl:right-10"
									/>
									<img
										*ngIf="keyWord.value"
										(click)="keyWord.setValue('')"
										class="cursor-pointer absolute ltr:right-3 rtl:left-3 top-[15px] inline-block"
										src="./assets/images/close-square.svg"
										alt=""
									/>
								</mat-form-field>

								<div class="max-h-[250px] overflow-y-auto">
									<mat-option
										*ngFor="let option of serviceProviders"
										[value]="option"
									>
										{{ option?.businessName }}
									</mat-option>
									<mat-option
										disabled
										class="only-check"
										*ngIf="!serviceProviders?.length"
									>
										{{ 'GENERAL.NO_SP_FOUND' | translate }}
									</mat-option>
								</div>
							</div>
						</mat-select>
					</mat-form-field>
					<div
						*ngIf="getController('offerServiceProviders').value?.length"
						class="flex flex-wrap gap-2 mt-3"
					>
						<div
							*ngFor="
								let selectedService of getController('offerServiceProviders')
									?.value
							"
							class="flex justify-center p-3 rounded-[50px] bg-gradient text-off-white mb-3"
						>
							<p class="mb-0 whitespace-nowrap">
								{{ selectedService?.businessName }}
							</p>
							<img
								(click)="
									deleteServiceProvider(selectedService); isChanged = true
								"
								class="mx-1 mt-0.5 h-[16px] w-[16px] cursor-pointer"
								alt="icon"
								src="assets/images/close-circle-white.png"
							/>
						</div>
					</div>
				</div>
				<div
					*ngIf="!editMode && !isAddMode"
					class="w-full pt-[17px] m-0 p-0 border-solid border-b-2"
				>
					<p class="mb-0 pb-0 text-[#6E7191]">
						{{ 'OFFERS.SP' | translate }}
					</p>
					<p *ngIf="offerData?.isForAllProviders" class="viewMode">
						{{ 'OFFERS.ALL' | translate }}
					</p>
					<p *ngIf="!offerData?.isForAllProviders" class="mb-0">
						{{ 'OFFERS.INDIVIDUAL' | translate }}
					</p>
					<div
						*ngIf="!offerData?.isForAllProviders"
						class="flex flex-wrap gap-1 lg:gap-3 mt-0 pt-0"
					>
						<div
							*ngFor="let selectedValuee of offerData?.offerServiceProviders"
							class="flex justify-center p-3 rounded-[50px] bg-gradient text-off-white my-3"
						>
							<p class="mb-0 whitespace-nowrap">
								{{ selectedValuee?.businessName }}
							</p>
						</div>
					</div>
				</div>
				<!-- type -->
				<div *ngIf="editMode || isAddMode" class="mt-[16px]">
					<p class="text-font-16 text-dark-grey ltr:DIN-Bold font-bold">
						{{ 'OFFERS.TYPE' | translate }}
						<span class="text-[#7e2eb3]">*</span>
					</p>
					<mat-radio-group
						(change)="fixedMethodChanged()"
						formControlName="offerMethod"
						aria-label="Select an option"
					>
						<mat-radio-button
							(change)="
								fixedMethod = true;
								perMethod = false;
								getController('percentage').reset();
								getController('percentageDiscountAmountUpTo').reset()
							"
							[value]="0"
							[checked]="offerData?.offerMethod == 0"
							class="ltr:mr-[24px] rtl:ml-[24px] text-font-14 text-dark-grey"
							>{{ 'OFFERS.FIXED' | translate }}</mat-radio-button
						>
						<mat-radio-button
							(change)="
								fixedMethod = false;
								perMethod = true;
								getController('fixedAmount').reset();
								getController('fixedMinValue').reset()
							"
							class="text-font-14 text-dark-grey"
							[value]="1"
							[checked]="offerData?.offerMethod == 1"
							>{{ 'OFFERS.PERCENTAGE' | translate }}</mat-radio-button
						>
					</mat-radio-group>
				</div>

				<div
					*ngIf="!editMode && !isAddMode"
					class="w-full max-h-[73px] pt-[17px] m-0 p-0 border-solid border-b-2"
				>
					<p class="mb-0 pb-0 text-[#6E7191]">
						{{ 'OFFERS.TYPE' | translate }}
					</p>
					<p class="viewMode">
						{{
							offerData?.offerMethod == 0
								? ('OFFERS.FIXED' | translate)
								: ('OFFERS.PERCENTAGE' | translate)
						}}
					</p>
				</div>
				<!-------------------- if fixed type  ---------- -->
				<!-- amount -->
				<div
					*ngIf="
						(getController('offerMethod').value == 0 && editMode) ||
						fixedMethod ||
						(offerData?.offerMethod == 0 && !editMode && !perMethod)
					"
				>
					<mat-form-field
						*ngIf="editMode || isAddMode"
						class="w-full relative mt-[16px] custom_astric icon-custom"
						appearance="outline"
					>
						<mat-label class="text-dark-grey">{{
							'OFFERS.AMOUNT' | translate
						}}</mat-label>
						<img
							class="cursor-pointer w-[24px] ltr:left-2 absolute rtl:right-2 h-[24px] inline-block top-[16px]"
							src="./assets/images/dollar-circle.png"
							alt=""
						/>
						<input
							formControlName="fixedAmount"
							class="text-font-16 absolute text-[#4E4B66] mx-10"
							type="number"
							matInput
							[max]="5000"
							required
							[min]="1"
							placeholder="{{ 'OFFERS.AMOUNT' | translate }}"
						/>
						<span
							*ngIf="
								getController('countryId')?.value == 224 &&
								getController('fixedAmount')?.value
							"
							class="absolute ltr:right-12 rtl:left-12 top-4 text-dark-grey"
						>
							{{ 'CURRENCY.EGP' | translate }}
						</span>
						<span
							*ngIf="
								getController('countryId')?.value == 103 &&
								getController('fixedAmount')?.value
							"
							class="absolute ltr:right-12 rtl:left-12 top-4 text-dark-grey"
						>
							{{ 'CURRENCY.SAR' | translate }}
						</span>

						<img
							*ngIf="
								getController('fixedAmount')?.value &&
								((editMode && offerData?.appointmentsCount == 0) || isAddMode)
							"
							(click)="getController('fixedAmount').reset()"
							class="cursor-pointer absolute ltr:right-3 rtl:left-3 top-[15px] inline-block"
							src="./assets/images/close-square.svg"
							alt=""
						/>
						<mat-error>
							<validation-message
								[controller]="getController('fixedAmount')"
								controller_name="OFFERS.AMOUNT"
								pattern_Message="VALIDATION.ONLY_NUMBERS"
							>
							</validation-message>
						</mat-error>
					</mat-form-field>
					<div
						*ngIf="!editMode && !isAddMode"
						class="w-full max-h-[73px] pt-[17px] m-0 p-0 border-solid border-b-2"
					>
						<p class="mb-0 pb-0 text-[#6E7191]">
							{{ 'OFFERS.AMOUNT' | translate }}
						</p>
						<div class="flex">
							<p class="viewMode">{{ offerData?.fixedAmount }}</p>
							<p class="viewMode mx-2">
								{{
									translate.currentLang == 'ar'
										? offerData?.currency?.name?.ar
										: offerData?.currency?.name?.en
								}}
							</p>
						</div>
					</div>
					<!-- min booking value -->
					<mat-form-field
						*ngIf="editMode || isAddMode"
						class="w-full relative"
						appearance="outline"
					>
						<mat-label class="text-dark-grey">{{
							'OFFERS.MIN_PRICE' | translate
						}}</mat-label>
						<input
							formControlName="fixedMinValue"
							class="text-font-16 text-[#4E4B66]"
							type="number"
							matInput
							[min]="getController('fixedAmount').value + 1"
							maxlength="6"
							placeholder="{{ 'OFFERS.MIN_PRICE' | translate }}"
						/>
						<span
							*ngIf="
								getController('countryId')?.value == 224 &&
								getController('fixedMinValue')?.value
							"
							class="absolute ltr:right-12 rtl:left-12 top-4 text-dark-grey"
						>
							{{ 'CURRENCY.EGP' | translate }}
						</span>
						<span
							*ngIf="
								getController('countryId')?.value == 103 &&
								getController('fixedMinValue')?.value
							"
							class="absolute ltr:right-12 rtl:left-12 top-4 text-dark-grey"
						>
							{{ 'CURRENCY.SAR' | translate }}
						</span>

						<img
							*ngIf="
								getController('fixedMinValue')?.value &&
								((editMode && offerData?.appointmentsCount == 0) || isAddMode)
							"
							(click)="getController('fixedMinValue').reset()"
							class="cursor-pointer absolute ltr:right-3 rtl:left-3 top-[15px] inline-block"
							src="./assets/images/close-square.svg"
							alt=""
						/>
						<mat-error>
							<validation-message
								[controller]="getController('fixedMinValue')"
								controller_name="'OFFERS.MIN_PRICE'"
								pattern_Message="VALIDATION.ONLY_NUMBERS"
							>
							</validation-message>
						</mat-error>
					</mat-form-field>

					<div
						*ngIf="!editMode && !isAddMode"
						class="w-full max-h-[73px] pt-[17px] m-0 p-0"
					>
						<p class="mb-0 pb-0 text-[#6E7191]">
							{{ 'OFFERS.MIN_PRICE' | translate }}
						</p>
						<div class="flex">
							<p class="viewMode">{{ offerData?.fixedMinValue }}</p>
							<p class="viewMode mx-2">
								{{
									translate.currentLang == 'ar'
										? offerData?.currency?.name?.ar
										: offerData?.currency?.name?.en
								}}
							</p>
						</div>
					</div>
				</div>

				<!-------------------- if percentage type  ---------- -->
				<!-- amount -->
				<div
					*ngIf="
						(getController('offerMethod').value == 1 && editMode) ||
						perMethod ||
						(offerData?.offerMethod == 1 && !editMode && !fixedMethod)
					"
				>
					<mat-form-field
						*ngIf="editMode || isAddMode"
						class="w-full relative mt-[16px] custom_astric icon-custom"
						appearance="outline"
					>
						<mat-label class="text-dark-grey">{{
							'OFFERS.PERCENTAGE_AMOUNT' | translate
						}}</mat-label>
						<img
							class="cursor-pointer w-[24px] ltr:left-2 absolute rtl:right-2 h-[24px] inline-block top-[16px]"
							src="./assets/images/percentage-circle.png"
							alt=""
						/>
						<input
							formControlName="percentage"
							class="text-font-16 text-[#4E4B66] mx-10"
							type="text"
							matInput
							maxlength="3"
							required
							(keypress)="validateInput($event)"
							[max]="100"
							[min]="1"
							placeholder="{{ 'OFFERS.PERCENTAGE_AMOUNT' | translate }} "
						/>
						<p
							*ngIf="getController('percentage')?.value"
							class="absolute top:0 rtl:right-20 ltr:left-20 inline-block top-[13px]"
						>
							%
						</p>
						<img
							*ngIf="
								getController('percentage')?.value &&
								((editMode && offerData?.appointmentsCount == 0) || isAddMode)
							"
							(click)="getController('percentage').reset()"
							class="cursor-pointer absolute ltr:right-3 rtl:left-3 top-[15px] inline-block"
							src="./assets/images/close-square.svg"
							alt=""
						/>
						<mat-error>
							<validation-message
								[controller]="getController('percentage')"
								controller_name="OFFERS.PERCENTAGE_AMOUNT"
								pattern_Message="VALIDATION.PERCENTAGE"
							>
							</validation-message>
						</mat-error>
					</mat-form-field>
					<div
						*ngIf="!editMode && !isAddMode"
						class="w-full max-h-[73px] pt-[17px] m-0 p-0 border-solid border-b-2"
					>
						<p class="mb-0 pb-0 text-[#6E7191]">
							{{ 'OFFERS.PERCENTAGE_AMOUNT' | translate }}
						</p>
						<p class="viewMode">{{ offerData?.percentage }}%</p>
					</div>
					<!-- up to value -->
					<mat-form-field
						*ngIf="editMode || isAddMode"
						class="w-full relative"
						appearance="outline"
					>
						<mat-label class="text-dark-grey">{{
							'OFFERS.DIS_UP_TO' | translate
						}}</mat-label>
						<input
							(keypress)="validateInput($event)"
							formControlName="percentageDiscountAmountUpTo"
							class="text-font-16 text-[#4E4B66]"
							type="text"
							matInput
							maxlength="3"
							placeholder="{{ 'OFFERS.DIS_UP_TO' | translate }}"
						/>
						<span
							*ngIf="
								getController('countryId')?.value == 224 &&
								getController('percentageDiscountAmountUpTo')?.value
							"
							class="absolute ltr:right-12 rtl:left-12 top-4 text-dark-grey"
						>
							{{ 'CURRENCY.EGP' | translate }}
						</span>
						<span
							*ngIf="
								getController('countryId')?.value == 103 &&
								getController('percentageDiscountAmountUpTo')?.value
							"
							class="absolute ltr:right-12 rtl:left-12 top-4 text-dark-grey"
						>
							{{ 'CURRENCY.SAR' | translate }}
						</span>
						<!-- Validators.pattern('^(?=[0-9.])[0-9]{0,2}$|^100$'), -->
						<!-- <p
							*ngIf="getController('percentageDiscountAmountUpTo')?.value"
							class="absolute top:0 rtl:right-9 ltr:left-9 inline-block top-[13px]"
						></p> -->
						<img
							*ngIf="
								getController('percentageDiscountAmountUpTo')?.value &&
								((editMode && offerData?.appointmentsCount == 0) || isAddMode)
							"
							(click)="getController('percentageDiscountAmountUpTo').reset()"
							class="cursor-pointer absolute ltr:right-3 rtl:left-3 top-[15px] inline-block"
							src="./assets/images/close-square.svg"
							alt=""
						/>
						<mat-error>
							<validation-message
								[controller]="getController('percentageDiscountAmountUpTo')"
								controller_name=" OFFERS.DIS_UP_TO"
								pattern_Message="VALIDATION.NAME"
							>
							</validation-message>
						</mat-error>
					</mat-form-field>
					<div
						*ngIf="!editMode && !isAddMode"
						class="w-full max-h-[73px] pt-[17px] m-0 p-0 border-solid border-b-2"
					>
						<p class="mb-0 pb-0 text-[#6E7191]">
							{{ 'OFFERS.UP_TO' | translate }}
						</p>

						<p class="viewMode">
							{{ offerData?.percentageDiscountAmountUpTo }}
							{{
								translate.currentLang == 'ar'
									? offerData?.currency?.name?.ar
									: offerData?.currency?.name?.en
							}}
						</p>
					</div>
				</div>
				<div class="flex items-center mt-[10px]">
					<h1 class="text-dark-grey text-font-16 m-0">
						{{ 'OFFERS.CLIENT_VISIBILITY' | translate }}
					</h1>
					<mat-checkbox
						class="mx-[10px]"
						[disabled]="!editMode && !isAddMode"
						(change)="
							offerForm.controls['clientVisibility'].setValue($event.checked)
						"
						[checked]="this.getController('clientVisibility').value"
					></mat-checkbox>
				</div>
			</div>
			<!-- Action Buttons start -->
			<div class="flex justify-end" *ngIf="editMode && !isAddMode">
				<div class="flex">
					<button
						(click)="changeEditMode(); initForm(); isChanged = false"
						class="border border-solid text-dark-grey border-[#D9DBE9] hover:bg-gradient hover:text-off-white mx-2"
						mat-button
					>
						{{ 'ACTIONS.CANCEL' | translate }}
					</button>

					<button
						[disabled]="offerForm.invalid || !isChanged"
						(click)="
							offerData?.appointmentsCount == 0 ? updateData() : openDialog()
						"
						class="bg-gradient text-off-white rounded"
						mat-button
					>
						{{ 'ACTIONS.SAVE' | translate }}
					</button>
				</div>
			</div>
			<!-- Action Buttons End -->
		</div>
		<!-- </div> -->
	</div>
</div>
